export const formatCityAndCountry = (city?: string, country?: string): string | undefined => {
  const parts = [city, country].filter((i) => !!i)

  return parts.length ? parts.join(", ") : undefined
}
